import { jsx as o } from "react/jsx-runtime";
import "react";
import { Box as t } from "@vp/swan";
import { SearchContextProvider as n } from "./help-center-articles-search3.js";
import i from "./help-center-articles-search4.js";
import { normalizeLocale as l } from "./help-center-articles-search5.js";
const g = (e) => {
  const r = l(e.locale), a = `${e.resultsPageUrl || "/search?querycat=helpcenter&q="}`;
  return /* @__PURE__ */ o(
    n,
    {
      applicationName: e.applicationName,
      locale: r,
      logger: e.logger,
      resultsPageUrl: a,
      environment: e.environment || "prod",
      children: /* @__PURE__ */ o(t, { "data-testid": "search-application-name", children: /* @__PURE__ */ o(
        i,
        {
          variation: e.variation,
          onQueryResultsChange: e.onQueryResultsChange,
          comboboxOverrides: e.comboboxOverrides
        }
      ) })
    }
  );
};
export {
  g as default
};
//# sourceMappingURL=help-center-articles-search2.js.map
